import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputPhoneErrorMessage = (
  <Trans>
    Ce champ doit contenir un numéro de téléphone valide
  </Trans>
);
